<script setup>
import {defineProps, defineEmits} from "vue";
import LinhaDeContasAPagar from "./LinhaDeContasAPagar/LinhaDeContasAPagar.vue";

//==================================================================//
//========================= Props / Emits ==========================//
//==================================================================//

const props = defineProps([
    "controlesDesativados",
    "dado",
]);

const emits = defineEmits([
    "update:alteraContaAPagar",
    "update:alteraPagamento",
]);

//==================================================================//
//================== Altera Conta a Pagar ==========================//
//==================================================================//

const alteraContaAPagar = (update = {})=>{

    emits('update:alteraContaAPagar',update);

};

//==================================================================//
//==================== Altera Pagamento ============================//
//==================================================================//

const alteraPagamento = (update = {})=>{

    emits('update:alteraPagamento',update);

};

</script>

<template>

    <div class="c-table__body">

        <LinhaDeContasAPagar v-for="contaAPagar in props?.dado?.contasAPagar"
            :key="contaAPagar.id"
            :controlesDesativados="props?.controlesDesativados"
            :dado="props?.dado"
            :contaAPagar="contaAPagar"
            @update:alteraContaAPagar="alteraContaAPagar"
            @update:alteraPagamento="alteraPagamento"
        ></LinhaDeContasAPagar>

    </div>

</template>

<style scoped>

.c-table__body{
    display: grid;
    grid-template-columns: subgrid;
    grid-column: 1 / -1;
}

</style>